import omit from 'lodash/omit';
import FeedbacksConstants from 'Shared/constants/Feedbacks.constants';
import FeedbackCommentsConstants from 'Shared/constants/FeedbackComments.constants';

import { mapObjectsForRedux } from './utils';

const feedbackComments = (state = [], action) => {
  switch (action.type) {
    case FeedbacksConstants.Actions.FETCH_FEEDBACK_COMMENTS_SUCCESS:
    case FeedbackCommentsConstants.Actions.CREATE_FEEDBACK_COMMENT_SUCCESS:
    case FeedbackCommentsConstants.Actions.UPDATE_FEEDBACK_COMMENT_SUCCESS:
    case FeedbackCommentsConstants.Actions.VIEW_FEEDBACK_COMMENT_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_FEEDBACKS_SUCCESS:
    case FeedbacksConstants.Actions.FEEDBACKS_SYNC_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_FEEDBACK_SUCCESS:
      return {
        ...state,
        ...mapObjectsForRedux(action.payload.feedbackComment),
      };
    case FeedbackCommentsConstants.Actions.CREATE_FEEDBACK_COMMENT_REQUEST:
    case FeedbackCommentsConstants.Actions.UPDATE_FEEDBACK_COMMENT_REQUEST:
    case FeedbackCommentsConstants.Actions.UPDATE_FEEDBACK_COMMENT_FAILURE:
    case FeedbackCommentsConstants.Actions.DESTROY_FEEDBACK_COMMENT_FAILURE:
      return { ...state, [action.payload.uuid]: action.payload };
    case FeedbackCommentsConstants.Actions.CREATE_FEEDBACK_COMMENT_FAILURE:
    case FeedbackCommentsConstants.Actions.DESTROY_FEEDBACK_COMMENT_REQUEST:
      return omit(state, action.payload);
    default:
      return state;
  }
};

export default feedbackComments;
